import { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import CustomNavItem from './Components/CustomNavItem';
import { FaCheck } from "react-icons/fa6"
import { toast } from 'react-toastify';
import { useParams } from '../Providers/ParamsProvider';
import { Licenses } from '../Data/Licenses.ts';

const CookieModal = () => {
    const tabs = ['Zgoda', 'Szczegóły', 'O plikach cookies']
    const [show, setShow] = useState(false)
    const [selectedTab, setSelectedTab] = useState(tabs[0])

    useEffect(() => {
        const isAccepted = localStorage.getItem('cookieConsent')
        if (isAccepted) {
            setShow(false)
        }
        else {
            setShow(true)
        }
    }, [])

    const handleAcceptCookies = () => {
        localStorage.setItem('cookieConsent', true)
        setShow(false)
    }

    const sectionSelector = () => {
        switch (selectedTab) {
            case 'Zgoda':
                return <MainSection />
            case 'Szczegóły':
                return <DetailsSection />
            case 'O plikach cookies':
                return <AboutCookiesSection />
        }
    }

    return (<Modal size='lg' centered show={show} backdrop='static' keyboard={false}>
        <Modal.Header closeButton={false}>
            <Modal.Title className='w-100'>
                <div className='d-flex justify-content-between align-items-center'>
                    <b>Pliki Cookies i dane lokalne</b>
                    <span>🍪</span>
                </div>
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <div className='w-100 mb-4'>
                <CustomNavItem
                    items={tabs}
                    defaultItem={tabs[0]}
                    onClick={(item) => setSelectedTab(item)}
                    isFullWidth={true}
                />
            </div>
            {sectionSelector()}
        </Modal.Body>
        <Modal.Footer>
            <div className='d-flex flex-column'>
                <button className='btn-app-primary me-3' onClick={handleAcceptCookies}>Rozumiem i akceptuję</button>
            </div>
        </Modal.Footer>
    </Modal>)
}

const MainSection = () => {
    return (<div className="d-flex justify-content-between align-items-center">
        <span>Nasz serwis wykorzystuje pliki cookie oraz technologię local storage, która działa podobnie do plików cookies w celu prawidłowego funkcjonowania strony.
            Nie wykorzystujemy plików cookies w celach analitycznych i marketingowych.
            Poprzez kliknięcie na przycisk „Rozumiem i akceptuję” wyrażasz zgodę na przechowywanie niezbędnych do działania strony plików cookie na swoim urządzeniu w
            celu poprawnego korzystania ze strony.
        </span>
    </div>)
}

const DetailsSection = () => {
    const { license } = useParams()

    return (<>
        <div className="row">
            <div className='d-flex justify-content-between align-items-center'>
                <b>Niezbędne pliki cookies i dane lokalne</b>
                <div className={`d-flex`} onClick={() => toast.warning('Nie możesz zrezygnowac z tej zgody!')}>
                    <div className='d-flex justify-content-end'></div>
                    <div className={`navbar-custom-switch active`}>
                        <div className="navbar-custom-switch-circle">
                            <FaCheck color='white' />
                        </div>
                    </div>
                </div>
            </div>
            <span className='mt-3'>Niektóre pliki cookies są niezbędne do prawidłowego wyświetlenia strony internetowej i pozwalają na korzystanie z jej funkcjonalności,
                w tym tych podstawowych jak nawigacja po serwisie, korzystanie z interaktywnych formularzy, dodawanie produktów do koszyka i składanie zamówienia.
            </span>
            <span className='mt-2'>Tego typu pliki cookies nie wymagają zgody użytkownika.</span>
        </div>
        {(license == Licenses.TgInstalacje || license == Licenses.Ferrodo) &&
            <div className="row mt-4">
                <a href='https://tginstalacje.pl/polityka-prywatnosci/' target="_blank">Polityka prywatności</a>
                <a href='https://tginstalacje.pl/polityka-cookies/' target="_blank">Polityka cookies</a>
            </div>}
    </>)
}

const AboutCookiesSection = () => {
    return (<div>
        <div className="row">
            <span>Cookies, czyli ciasteczka to małe pliki tekstowe wysyłane przez serwis internetowy, który przeglądasz i zapisywane na urządzeniu z którego korzystasz.
                Domyślne ustawienia przeglądarki internetowej zazwyczaj pozwalają nas zapisywanie ciasteczek i ich późniejsze odczytanie przez serwer, który je utworzył.
                W dowolnej chwili masz możliwość zmiany tych ustawień. Musisz jednak wiedzieć, że całkowita rezygnacja z zapisu cookies utrudni Ci korzystanie z niektórych funkcji
                przeglądanych serwisów. Ciasteczka zawierają informacje potrzebne do optymalnego funkcjonowania serwisów, w szczególności tych funkcji,
                które są potrzebne do autoryzacji (np. podczas logowania), uzupełnienia formularzy, czy personalizowania wyglądu.
                Nie jest możliwe zidentyfikowanie Twoich danych osobowych poprzez ciasteczka. Ponadto pliki te nie wpływają w żaden sposób na używane przez Ciebie oprogramowanie,
                ani urządzenie.</span>
        </div>
        <div className="row mt-3">
            <b className='mb-3'>USUWANIE COOKIES</b>
            <span>Możesz usunąć pliki cookies w dowolnym momencie zmieniając ustawienia w przeglądarce internetowej, której używasz.
                Masz możliwość usunięcia wcześniej zapisanych plików, jak i ograniczenia bieżącego zapisu częściowo lub w całości.</span>
        </div>
    </div>)
}

export default CookieModal